import { render, staticRenderFns } from "./StorehouseList.vue?vue&type=template&id=af2b82d4&scoped=true&"
import script from "./StorehouseList.vue?vue&type=script&lang=js&"
export * from "./StorehouseList.vue?vue&type=script&lang=js&"
import style0 from "./StorehouseList.vue?vue&type=style&index=0&id=af2b82d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2b82d4",
  null
  
)

export default component.exports